import { Core4Metric } from '../../../model/Entities';

/** HITTING **/

export const baseballCore4MetricExitVelocity: Core4Metric = {
    code: 'RSHEXITSPEED',
    categoryCode: 'HITTING',
    sportCode: 'BASEBALL',
    name: 'Exit Velocity',
    best: 'max',
    comparable: true,
};

export const baseballCore4MetricBatSpeed: Core4Metric = {
    code: 'BATSPEED',
    categoryCode: 'HITTING',
    sportCode: 'BASEBALL',
    name: 'Bat Speed',
    best: 'max',
    comparable: true,
};

export const baseballCore4MetricPeakHandSpeed: Core4Metric = {
    code: 'PEAKHANDSPEED',
    categoryCode: 'HITTING',
    sportCode: 'BASEBALL',
    name: 'Peak Hand Speed',
    best: 'max',
    comparable: true,
};

export const baseballCore4MetricTimeToContact: Core4Metric = {
    code: 'TIMETOCONTACT',
    categoryCode: 'HITTING',
    sportCode: 'BASEBALL',
    name: 'Time to Contact',
    best: 'min',
    comparable: true,
};

/** ARM VELOCITY **/

export const baseballCore4MetricPositionThrowVelocity: Core4Metric = {
    code: 'POSTHROWVEL',
    categoryCode: 'ARMVELOCITY',
    sportCode: 'BASEBALL',
    name: 'Position Throwing Velocity',
    best: 'max',
    comparable: true,
};

export const baseballCore4MetricFastballPitching: Core4Metric = {
    code: 'FASTBALLMAXSPEED',
    categoryCode: 'ARMVELOCITY',
    sportCode: 'BASEBALL',
    name: 'Fastball Max Speed (mph)',
    best: 'max',
    comparable: true,
};

/** SPEED & AGILITY **/

export const baseballCore4Metric10YD: Core4Metric = {
    code: '10YD',
    categoryCode: 'SPEEDAGILITY',
    sportCode: 'BASEBALL',
    name: '10 Yard Dash',
    best: 'min',
    comparable: true,
};

export const baseballCore4Metric30YD: Core4Metric = {
    code: '30YD',
    categoryCode: 'SPEEDAGILITY',
    sportCode: 'BASEBALL',
    name: '30 Yard Dash',
    best: 'min',
    comparable: true,
};

export const baseballCore4Metric5105: Core4Metric = {
    code: '5105',
    categoryCode: 'SPEEDAGILITY',
    sportCode: 'BASEBALL',
    name: '5-10-5',
    best: 'min',
    comparable: true,
};

/** STRENGTH **/

export const baseballCore4MetricVerticalJump: Core4Metric = {
    code: 'VERTICALJUMP',
    categoryCode: 'STRENGTH',
    sportCode: 'BASEBALL',
    name: 'Vertical Jump',
    best: 'max',
    comparable: true,
};

export const baseballCore4MetricHandGripRT: Core4Metric = {
    code: 'HANDGRIPRT',
    categoryCode: 'STRENGTH',
    sportCode: 'BASEBALL',
    name: 'Hand Grip Strength (RT)',
    best: 'max',
    comparable: true,
};

export const baseballCore4MetricHandGripLT: Core4Metric = {
    code: 'HANDGRIPLT',
    categoryCode: 'STRENGTH',
    sportCode: 'BASEBALL',
    name: 'Hand Grip Strength (LT)',
    best: 'max',
    comparable: true,
};
